module.exports = __webpack_public_path__ + "static/025_001-4d7f5bc84fe93d2adec668db6428ce22.jpg";